import { Component, Input, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Channel, BasicList} from 'app/interfaces/channel';
import { RadioListImage } from 'app/components/shared/bb-radio-list/bb-radio-list.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
	selector: 'channel-details-detailpage',
	templateUrl: './channel-details-detailpage.component.html',
	styleUrls: ['./channel-details-detailpage.component.scss']
})

export class ChannelDetailsDetailpageComponent implements OnInit {
	@Input() channel: Channel;
	@Input() form: NgForm;
	@Input() backgroundColorPreset: BasicList[];

	playerAlignmentOptions: RadioListImage[];

	constructor(
		private translate: TranslateService,
	) {
		this.playerAlignmentOptions = [
			{ label: this.translate.instant('LEFT'), value: 'left', imageUrl: '/resources/img/channels/PlayerAlignmentLeft.svg' }, // default
			{ label: this.translate.instant('RIGHT'), value: 'right', imageUrl: '/resources/img/channels/PlayerAlignmentRight.svg' }
		];
	}

	ngOnInit() {

	}
}
